var map = {
	"./icon_225JPY.png": "2c9c",
	"./icon_AAPL.png": "a21a",
	"./icon_AMZN.png": "6e56",
	"./icon_AUDUSD.png": "93c6",
	"./icon_AUDUSD_m.png": "26f1",
	"./icon_BRKb.png": "5dd1",
	"./icon_BTCUSD.png": "a4dd",
	"./icon_D30EUR.png": "2f39",
	"./icon_EURUSD.png": "f583",
	"./icon_EURUSD_m.png": "b778",
	"./icon_GBPUSD.png": "7345",
	"./icon_GBPUSD_m.png": "e4c1",
	"./icon_GLD.png": "1844",
	"./icon_GOOGL.png": "fa15",
	"./icon_ICLN.png": "7a86",
	"./icon_IVV.png": "c1b2",
	"./icon_META.png": "f2b1",
	"./icon_MSFT.png": "65c8",
	"./icon_NASUSD.png": "4981",
	"./icon_NVDA.png": "3230",
	"./icon_NZDUSD.png": "02fc",
	"./icon_QQQ.png": "57cc",
	"./icon_SMH.png": "ed6a",
	"./icon_SPXUSD.png": "9f85",
	"./icon_SPY.png": "759f",
	"./icon_TSLA.png": "a530",
	"./icon_U30USD.png": "e148",
	"./icon_USDCAD.png": "65d5",
	"./icon_USDJPY.png": "947a",
	"./icon_USDJPY_m.png": "9fd4",
	"./icon_VOO.png": "a646",
	"./icon_VTI.png": "6eac",
	"./icon_XAGUSD.png": "ca26",
	"./icon_XAUUSD.png": "6260",
	"./icon_XBRUSD.png": "7533",
	"./icon_XNGUSD.png": "f576",
	"./icon_XTIUSD.png": "b302"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "6a5a";